module.exports = {};throw new Error(`Could not resolve "@emotion/is-prop-valid" imported by "framer-motion". Is it installed?`)